import { Immutable } from "immer";
import React from "react";

import type { HeroImageBlock as Value } from "@reactivated";

// NOTE: This component reproduces the legacy server-rendered markup from
// `cms/home_page.html` (the non-theme branch of the hero-carousel loop)
// verbatim — every classname is load-bearing for the existing SCSS, so keep
// them in sync. The entire HeroImageBlock render is a single div with a
// background-image inline style.
type IProps = Immutable<{
    value: Value;
}>;

export const HeroImageBlock = (props: IProps): React.JSX.Element => {
    const image = props.value.image;
    // Legacy emitted `style="background-image: url(<url>);"` (unquoted). When
    // the image is null the legacy markup rendered `url()` (a broken url); we
    // instead omit the inline style entirely while keeping the wrapper element.
    // See the LifestyleModule precedent (omit style when image is null). We
    // quote the url to match the LifestyleModule sibling — CSS-equivalent to
    // the legacy unquoted form.
    const style: React.CSSProperties | undefined = image
        ? { backgroundImage: `url('${image.url}')` }
        : undefined;
    return (
        <div
            className="home-page-hero-carousel__image home-page-hero-height"
            style={style}
        ></div>
    );
};
